import { render, staticRenderFns } from "./TaskAppDueDate.vue?vue&type=template&id=56516638&lang=pug&"
import script from "./TaskAppDueDate.vue?vue&type=script&lang=js&"
export * from "./TaskAppDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VBtn,VDatePicker})
